import { AfterViewInit, Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../base.component';
import { DatePipe } from '@angular/common';
import { MiscService } from '../../services/misc.service';
import { ButtonLoaderDirective } from '../../directives/button-loader.directive';
import { finalize, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DocumentsService } from '../../services/documents.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpResponse } from '@angular/common/http';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';

@Component({
    selector: 'mobilize-option-details',
    imports: [
        DatePipe,
        ButtonLoaderDirective
    ],
    templateUrl: './option-details.component.html',
    styleUrl: './option-details.component.scss'
})
export class OptionDetailsComponent extends BaseComponent implements OnInit, AfterViewInit {

    insuranceOption = false;
    loaded = false;
    insurance!: any;
    requestSent = false;
    showButton = true;
    isProcessing = false;

    constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,
                private modalRef: MatDialogRef<OptionDetailsComponent>,
                private _dialog: MatDialog,
                private _documents: DocumentsService) {
        super();
    }

    get data(): any {
        return this.dialogData;
    }

    ngOnInit() {
        this.insurance = this.data.option;
        this.insuranceOption = !this.insurance.service_name;
        // this._misc.checkLastRequest({insurance: this.insurance}).subscribe(rsp => {
        //     this.showButton = !rsp.data;
        //     if (!this.showButton) this.requestSent = true;
        // })
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.loaded = true;
        }, 2000);
    }

    closeModal() {
        this.modalRef.close();
    }

    getDocument() {

        // this.isProcessing = true;
        // const payload: any = {
        //     site_id: !this.insuranceOption ? '' : this.insurance.insurance_site_id,
        //     id: !this.insuranceOption ? this.insurance.contract_service_id : this.insurance.insurance_id,
        //     details: this.insurance
        // }
        // this._misc.requestDocument(payload).subscribe(rsp => {
        //     this.requestSent = true;
        //     this.isProcessing = false;
        // });

        this.isProcessing = true;

        let documentType = '';

        switch (this.insurance.insurance_type) {
            case 'Asigurare Trafic Accident':
                documentType = 'adi'
                break;

            case 'Polita CASCO':
                documentType = 'casco';
                break;

            case 'RCA':
                documentType = 'rca';
                break;
        }

        this._documents.getContractDocuments({
            contractId: this.insurance.contract_id,
            type: documentType
        })
            .pipe(
                finalize(() => {
                    this.isProcessing = false;
                }),
                catchError(((err: any) => {
                    this._dialog.open(ConfirmModalComponent, {
                        data: {
                            title: 'Documentul nu a putut fi descarcat.',
                            content: `Te rog sa transmiti o solicitare pentru acest document catre rcileasing.romania@mobilize-fs.com`,
                            noCancel: true,
                            confirmText: 'Ok'
                        }
                    });
                    return of(false);
                }))
            )
            .subscribe((response: HttpResponse<Blob>) => {
                // Check for a response body
                if (!response || !response.body) {
                    console.error('No response body received');
                    return;
                }

                // Extract filename from Content-Disposition
                const contentDisposition = response.headers.get('Content-Disposition');
                let fileName = 'default-filename.pdf';
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match && match[1]) {
                        fileName = match[1].replace(/['"]/g, '');
                    }
                }

                // Create a Blob and trigger the download
                const file = new Blob([response.body], {type: 'application/pdf'});
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(file);
                link.download = fileName;
                link.click();

                // Clean up
                window.URL.revokeObjectURL(link.href);
                link.remove();

            });
    }
}
